import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-quicksearch-detail',
    templateUrl: './quicksearch-detail.component.html',
    styleUrls: ['./quicksearch-detail.component.scss'],
    standalone: false
})
export class QuicksearchDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
